import { ALERT_ICON_PATH, BACK_ICON_PATH, T_LOGO_ICON_PATH } from '@/consts/imgPath';

interface IProps {
  onClickBackBtn: () => void;
}

const SendViewHeader = ({ onClickBackBtn }: IProps) => {
  return (
    <header className="ili-header sticky-header">
      <a href="#" className="back-area" onClick={onClickBackBtn}>
        <img src={BACK_ICON_PATH} alt="back-icon" />
      </a>
      <a className="inner" href="#">
        <div className="img">
          <img src={T_LOGO_ICON_PATH} alt="Logo" />
        </div>
        <h2>보내기</h2>
      </a>
      <div className="icon-area">
        <img src={ALERT_ICON_PATH} alt="alert-icon" style={{ opacity: 0 }} />
      </div>
    </header>
  );
};

export default SendViewHeader;
